import { RootState } from "../../../store";
import { AccountId } from "../../../../services/cloudchipr.api";

export const currentAccountIdSelector = (state: RootState): AccountId | null =>
  state.account.id;
